'use client'
import { memo } from 'react'

import FirstCheckMark from '@assets/images/why_book_check_1.webp'
import SecondCheckMark from '@assets/images/why_book_check_2.webp'
import ThirdCheckMark from '@assets/images/why_book_check_3.webp'
import {
  RaButton,
  RaContainer,
  RaHeading,
  RaIllustration,
  RaRichText,
  RaVisual,
} from '@components/core/index.core'
import { useSettings } from '@contexts/settings.context'
import { Loop } from '@utilities/helpers/core.helpers'

import styles from './acf-why-book-at.module.scss'

export const AcfWhyBookAt = memo(() => {
  const { themeSettings } = useSettings()

  if (!themeSettings) return null

  const { why_book_title, why_book_cta, why_book_statements } = themeSettings

  return (
    <div className={styles['acf-why-book-at']}>
      <RaContainer>
        <div className={styles['acf-why-book-at__content']}>
          <RaIllustration
            index={0}
            color="light"
          />
          <div className={styles['acf-why-book-at__heading']}>
            <RaHeading
              component="h2"
              color="light"
              noPadding>
              {why_book_title}
            </RaHeading>
            {why_book_cta && (
              <RaButton
                variant="secondary-footer"
                link={why_book_cta}
              />
            )}
          </div>
        </div>
        <div className={styles['acf-why-book-at__columns']}>
          {Loop(why_book_statements, (column, i) => {
            let image = null
            switch (i) {
              case 0:
              default:
                image = FirstCheckMark
                break
              case 1:
                image = SecondCheckMark
                break
              case 2:
                image = ThirdCheckMark
                break
            }
            return (
              <div
                key={i}
                className={styles['acf-why-book-at__column']}>
                <div className={styles['acf-why-book-at__checkmark']}>
                  <img
                    src={image.src}
                    alt="checkmark"
                    width={60}
                    height={60}
                    loading="lazy"
                    style={{
                      objectFit: 'contain',
                    }}
                  />
                </div>
                <RaHeading
                  component="h3"
                  color="light">
                  {column.statement_title}
                </RaHeading>
                {column.statement_text && (
                  <RaRichText content={column.statement_text} />
                )}
              </div>
            )
          })}
        </div>
        {why_book_cta && (
          <div className={styles['acf-why-book-at__footer']}>
            <RaButton
              variant="secondary-footer"
              link={why_book_cta}
            />
          </div>
        )}
      </RaContainer>
      <RaVisual color="light" />
    </div>
  )
})
